// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"4174":"b18f2c1315","6778":"6615d97b62"}[chunkId] + ".chunk.css";
};